// axios config
let baseURl = "";
if (window.location.host == "sait.cascadecms.com") {
    baseURl = 'https://www.sait.ca';
} else if (window.location.host == "sait-dev.cascadecms.com") {
    baseURl = 'https://app-saitca-marketing-01.azurewebsites.net';
} else if (window.location.host == "app-saitca-marketing-01-dylan.azurewebsites.net") {
    baseURl = 'https://app-saitca-marketing-01-dylan.azurewebsites.net';
}
else if(window.location.host == "app-saitca-marketing-01.azurewebsites.net") {
    baseURl = 'https://app-saitca-marketing-01.azurewebsites.net';
}
else if(window.location.host == "app-saitca-prod-01.azurewebsites.net"){
    baseURl = 'https://app-saitca-prod-01.azurewebsites.net';
}
else if(window.location.host == "app-saitca-prod-02.azurewebsites.net"){
    baseURl = 'https://app-saitca-prod-02.azurewebsites.net';
}
else if(window.location.host == "app-saitca-marketing-02.azurewebsites.net")
{
    baseURl = 'https://app-saitca-marketing-02.azurewebsites.net';
}
else if(window.location.host == "app-saitca-prod-01-server-update.azurewebsites.net"){
    baseURl = 'https://app-saitca-prod-01-server-update.azurewebsites.net/';
}
else if(window.location.host == "app-saitca-prod-02-server-update-02.azurewebsites.net"){
    baseURl = 'https://app-saitca-prod-02-server-update-02.azurewebsites.net';
}
else if(window.location.host == "app-saitca-marketing-01-elisa.azurewebsites.net"){
    baseURl = 'https://app-saitca-marketing-01-elisa.azurewebsites.net';
}
else if(window.location.host == "app-saitca-marketing-01-wemi.azurewebsites.net"){
    baseURl = 'https://app-saitca-marketing-01-wemi.azurewebsites.net';
    //baseURl = 'https://app-saitca-marketing-01-elisa.azurewebsites.net';
}
else if(window.location.host == "app-saitca-marketing-01-alyssa.azurewebsites.net"){
    baseURl = 'https://app-saitca-marketing-01-alyssa.azurewebsites.net';
}
else if(window.location.host == "app-saitca-marketing-01-yi.azurewebsites.net"){
    baseURl = 'https://app-saitca-marketing-01-yi.azurewebsites.net';
}
else {
    baseURl = 'https://www.sait.ca';
}

export default {
    baseURL: baseURl
}